import { render } from "./BankAccountComponent.vue?vue&type=template&id=c4a323b0"
import script from "./BankAccountComponent.vue?vue&type=script&lang=js"
export * from "./BankAccountComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__